
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec38d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec38d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $37a8dbb25a3f848f$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["6oMUc","index.d91d741e.js","6T6AY","card_back.96285401.svg","eSRz6","ace_of_hearts.cac46dc9.svg","kfTJN","2_of_hearts.10d04a5c.svg","iZPCH","3_of_hearts.c2f95fac.svg","gZXRZ","4_of_hearts.2a23f450.svg","exp7S","5_of_hearts.21a1f2e3.svg","8MSpZ","6_of_hearts.d3df7e5d.svg","6Wv7h","7_of_hearts.3451cf52.svg","1tOBl","8_of_hearts.738bb432.svg","5YBSS","9_of_hearts.93b7c079.svg","dqTHC","10_of_hearts.48563469.svg","dbXTh","jack_of_hearts.d4fa6ff2.svg","lYwcd","queen_of_hearts.7e5b4c05.svg","8BX3p","king_of_hearts.8a765958.svg","hy4Ta","ace_of_diamonds.3ed23edc.svg","kMwvb","2_of_diamonds.db899b18.svg","l0g5u","3_of_diamonds.1703e609.svg","eCIB7","4_of_diamonds.97012a91.svg","fw424","5_of_diamonds.9674f744.svg","5sX2B","6_of_diamonds.69b1f2ef.svg","8Xv9P","7_of_diamonds.b7308379.svg","gzCog","8_of_diamonds.7627c284.svg","h3qoc","9_of_diamonds.f8e9ad8a.svg","erIx1","10_of_diamonds.f05860ba.svg","8M7MA","jack_of_diamonds.8b5d6bec.svg","b0IZ8","queen_of_diamonds.5988f4c9.svg","k26u6","king_of_diamonds.4bbdc85e.svg","5fpnp","ace_of_clubs.271b4662.svg","hxFyr","2_of_clubs.963aced5.svg","bHwpL","3_of_clubs.73910735.svg","hMoNz","4_of_clubs.0e7a6885.svg","97jK1","5_of_clubs.156b0193.svg","WGgpH","6_of_clubs.bc9b6841.svg","5bxDB","7_of_clubs.6c15cd4f.svg","cpjSM","8_of_clubs.42484cb7.svg","jRA76","9_of_clubs.dfbb5b7f.svg","6mjXd","10_of_clubs.2fc5b090.svg","6ebhM","jack_of_clubs.6867ffc0.svg","5Guva","queen_of_clubs.80925cd4.svg","i09zQ","king_of_clubs.e80590e5.svg","10lRb","ace_of_spades.1d461cd0.svg","yYvG1","2_of_spades.6de5df24.svg","fLjCH","3_of_spades.f94cc10a.svg","fSZsv","4_of_spades.a3b78c8b.svg","i3bW0","5_of_spades.4df0b74d.svg","6mTuh","6_of_spades.9f195352.svg","2BnwH","7_of_spades.8192f738.svg","i4UPJ","8_of_spades.591a8726.svg","g1yUx","9_of_spades.44d32443.svg","8oPXu","10_of_spades.bb362507.svg","iTWav","jack_of_spades.4fda5cd4.svg","gqNrx","queen_of_spades.64d7836d.svg","cAtuy","king_of_spades.8c554a4f.svg","jIgJD","stand-on-15-high-resolution-logo-twitter.be96a630.png"]'));

class $5037474ddd94d2c5$export$8153bc6ccd5b11ae {
    constructor(suit, value){
        this.suit = suit;
        this.value = value;
    }
}


class $e2c2566beacade6b$export$c506b6be639682e0 {
    _suits = [
        "hearts",
        "diamonds",
        "clubs",
        "spades"
    ];
    _values = [
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "jack",
        "queen",
        "king",
        "ace"
    ];
    fullDeck = [];
    constructor(){
        this._InitializeDeck();
        this._ShuffleDeck();
    }
    _InitializeDeck() {
        for (let suit of this._suits)for (let value of this._values)this.fullDeck.push(new (0, $5037474ddd94d2c5$export$8153bc6ccd5b11ae)(suit, value));
    }
    _ShuffleDeck() {
        for(let i = this.fullDeck.length - 1; i > 0; i--){
            let j = Math.floor(Math.random() * (i + 1));
            [this.fullDeck[i], this.fullDeck[j]] = [
                this.fullDeck[j],
                this.fullDeck[i]
            ];
        }
    }
}


class $3d799ddff4431522$var$GameModel {
    state = {
        recommendation: "",
        answer: "",
        details: "",
        streak: 0,
        missed: [],
        allCards: [],
        allAces: [],
        aces: false,
        pairs: false,
        dealer: {
            score: [],
            cards: []
        },
        user: {
            score: [],
            cards: []
        }
    };
}
var $3d799ddff4431522$export$2e2bcd8739ae039 = new $3d799ddff4431522$var$GameModel();


"use strict";
class $d743b5eb20e9f5e4$var$GameLogic {
    Deal(reDeal = false, aces = false, pairs = false) {
        console.log(reDeal, aces, pairs);
        console.log((0, $3d799ddff4431522$export$2e2bcd8739ae039).state);
        if ((0, $3d799ddff4431522$export$2e2bcd8739ae039).state.allCards.length < 5 || reDeal) {
            const allCards = this.GetDecks();
            (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.allCards = allCards;
        }
        if (reDeal) {
            (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.streak = 0;
            (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.missed = [];
            (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.aces = false;
            (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.pairs = false;
        }
        if (aces) {
            (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.aces = true;
            (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.pairs = false;
            this._DealAces();
            return;
        }
        if (pairs) {
            (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.pairs = true;
            (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.aces = false;
            this._DealPairs();
            return;
        }
        this.DealNext();
    }
    DealNext() {
        if ((0, $3d799ddff4431522$export$2e2bcd8739ae039).state.aces) {
            this._DealAces();
            return;
        }
        if ((0, $3d799ddff4431522$export$2e2bcd8739ae039).state.pairs) {
            this._DealPairs();
            return;
        }
        if ((0, $3d799ddff4431522$export$2e2bcd8739ae039).state.allCards.length < 5) {
            const allCards = this.GetDecks();
            (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.allCards = allCards;
        }
        const delt = [];
        for(let i = 0; i < 4; i++)delt.push((0, $3d799ddff4431522$export$2e2bcd8739ae039).state.allCards.shift());
        const dealerDownCard = delt[1];
        const dealerUpCard = delt[3];
        const userFirstCard = delt[0];
        const userSecondCard = delt[2];
        (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.dealer.cards = [
            dealerDownCard,
            dealerUpCard
        ];
        (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.dealer.score = [
            +dealerDownCard.value + +dealerUpCard.value
        ];
        (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.user.cards = [
            userFirstCard,
            userSecondCard
        ];
        this.CalculateScores();
    }
    _DealPairs() {
        const delt = [];
        for(let i = 0; i < 3; i++)delt.push((0, $3d799ddff4431522$export$2e2bcd8739ae039).state.allCards.shift());
        const dealerDownCard = delt[1];
        const dealerUpCard = delt[2];
        const userFirstCard = delt[0];
        let userSecondCard = (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.allCards.find((card)=>card.value === userFirstCard.value);
        if (!userSecondCard) {
            const allCards = this.GetDecks();
            (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.allCards = allCards;
            userSecondCard = (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.allCards.find((card)=>card.value === userFirstCard.value);
        }
        (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.dealer.cards = [
            dealerDownCard,
            dealerUpCard
        ];
        (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.dealer.score = [
            +dealerDownCard.value + +dealerUpCard.value
        ];
        (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.user.cards = [
            userFirstCard,
            userSecondCard
        ];
        this.CalculateScores();
    }
    _DealAces() {
        const allCards = this.GetDecks();
        (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.allCards = allCards;
        if ((0, $3d799ddff4431522$export$2e2bcd8739ae039).state.allAces.length < 2) (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.allAces = (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.allCards.filter((card)=>{
            if (card.value === "ace") return card;
        });
        const delt = [];
        for(let i = 0; i < 3; i++)delt.push((0, $3d799ddff4431522$export$2e2bcd8739ae039).state.allCards.shift());
        const randomIndex = Math.trunc(Math.random() * 15 + 1);
        const dealerDownCard = delt[1];
        const dealerUpCard = delt[2];
        const userFirstCard = randomIndex % 2 != 0 ? (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.allAces[randomIndex] : delt[0];
        const userSecondCard = randomIndex % 2 === 0 ? (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.allAces[randomIndex] : delt[0];
        (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.dealer.cards = [
            dealerDownCard,
            dealerUpCard
        ];
        (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.dealer.score = [
            +dealerDownCard.value + +dealerUpCard.value
        ];
        (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.user.cards = [
            userFirstCard,
            userSecondCard
        ];
        this.CalculateScores();
    }
    _AddScores(acc, card) {
        if (card.value === "jack" || card.value === "queen" || card.value === "king") return acc + 10;
        if (card.value === "ace") return acc + 1;
        return acc + +card.value;
    }
    CalculateScores() {
        (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.user.score = (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.user.cards.reduce(this._AddScores, 0);
        (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.dealer.score = (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.dealer.cards.reduce(this._AddScores, 0);
    }
    _HandleAces(numberCard, showCard) {
        switch(numberCard){
            case 2:
            case 3:
                (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.details = "Double-Down if 5 - 6 else Hit";
                if (showCard >= 5 && showCard <= 6) {
                    (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.recommendation = "Double";
                    return;
                } else {
                    (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.recommendation = "Hit";
                    return;
                }
                break;
            case 4:
            case 5:
                (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.details = "Double-Down if 4 - 6 else Hit";
                if (showCard >= 4 && showCard <= 6) {
                    (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.recommendation = "Double";
                    return;
                } else {
                    (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.recommendation = "Hit";
                    return;
                }
                break;
            case 6:
                (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.details = "Double-Down if 3 - 6 else Hit";
                if (showCard >= 3 && showCard <= 6) {
                    (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.recommendation = "Double";
                    return;
                } else {
                    (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.recommendation = "Hit";
                    return;
                }
                break;
            case 7:
                (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.details = "Double-Down if 2 - 6, Stand if 7 - 8, else Hit";
                if (showCard >= 2 && showCard <= 6) {
                    (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.recommendation = "Double";
                    return;
                }
                if (showCard >= 7 && showCard <= 8) {
                    (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.recommendation = "Stand";
                    return;
                }
                (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.recommendation = "Hit";
                return;
            case 8:
                (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.details = "Double-Down if 6 else Stand";
                if (showCard === 6) {
                    (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.recommendation = "Double";
                    return;
                } else {
                    (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.recommendation = "Stand";
                    return;
                }
                break;
            case 9:
                (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.details = "Always Stand";
                (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.recommendation = "Stand";
                return;
            default:
                (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.recommendation = "Blackjack!";
                return;
        }
    }
    _HandlePairs(cardValue, showCard) {
        switch(cardValue){
            case 1:
                (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.details = "Always Split Ace's and 8's";
                (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.recommendation = "Split";
                return;
            case 2:
            case 3:
                (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.details = "Split if 2 - 7 else Hit";
                if (showCard >= 2 && showCard <= 7) {
                    (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.recommendation = "Split";
                    return;
                } else {
                    (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.recommendation = "Hit";
                    return;
                }
                break;
            case 4:
                (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.details = "Split if 5 - 6 else Hit";
                if (showCard === 5 || showCard === 6) {
                    (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.recommendation = "Split";
                    return;
                } else {
                    (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.recommendation = "Hit";
                    return;
                }
                break;
            case 5:
                (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.details = "Double-Down if 2 - 9 else Hit";
                if (showCard >= 2 && showCard <= 9) {
                    (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.recommendation = "Double";
                    return;
                } else {
                    (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.recommendation = "Hit";
                    return;
                }
                break;
            case 6:
                (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.details = "Split if 2 - 6 else Hit";
                if (showCard >= 2 && showCard <= 6) {
                    (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.recommendation = "Split";
                    return;
                } else {
                    (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.recommendation = "Hit";
                    return;
                }
                break;
            case 7:
                (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.details = "Split if 2 - 7 else Hit";
                if (showCard >= 2 && showCard <= 7) {
                    (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.recommendation = "Split";
                    return;
                } else {
                    (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.recommendation = "Hit";
                    return;
                }
                break;
            case 8:
                (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.details = "Always Split Ace's and 8's";
                (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.recommendation = "Split";
                return;
            case 9:
                (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.details = "Split if 2 - 6 and 8 - 9, else Stand";
                if (showCard >= 2 && showCard <= 6 || showCard >= 8 && showCard <= 9) {
                    (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.recommendation = "Split";
                    return;
                } else {
                    (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.recommendation = "Stand";
                    return;
                }
                break;
            case 10:
                (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.details = "Always Stand";
                (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.recommendation = "Stand";
                return;
            default:
                break;
        }
    }
    GetRecommendation() {
        const fixCardValue = function(userCard) {
            const isNumber = parseInt(userCard);
            if (isNaN(isNumber) && userCard === "ace") return 1;
            else if (isNaN(isNumber)) return 10;
            else return +isNumber;
        };
        let userCard1Value = fixCardValue((0, $3d799ddff4431522$export$2e2bcd8739ae039).state.user.cards[0].value);
        let userCard2Value = fixCardValue((0, $3d799ddff4431522$export$2e2bcd8739ae039).state.user.cards[1].value);
        let showCard = fixCardValue((0, $3d799ddff4431522$export$2e2bcd8739ae039).state.dealer.cards[1].value);
        const userTotal = (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.user.score;
        const userCards = (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.user.cards[0];
        if (userCard1Value === userCard2Value) {
            this._HandlePairs(userCard1Value, showCard);
            return;
        }
        if (userCard1Value === 1 || userCard2Value === 1) {
            const numberCard = userCard1Value === 1 ? userCard2Value : userCard1Value;
            this._HandleAces(numberCard, showCard);
            return;
        }
        switch(userTotal){
            case 5:
            case 6:
            case 7:
            case 8:
                (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.recommendation = "Hit";
                (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.details = "On 5, 6, 7, 8 always Hit";
                return;
            case 9:
                (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.details = "Double-Down if 3 - 6 else Hit";
                if (showCard >= 3 && showCard <= 6) {
                    (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.recommendation = "Double";
                    return;
                } else {
                    (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.recommendation = "Hit";
                    return;
                }
                break;
            case 10:
                (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.details = "Double-Down if 2 - 9 else Hit";
                if (showCard >= 2 && showCard <= 9) {
                    (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.recommendation = "Double";
                    return;
                } else {
                    (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.recommendation = "Hit";
                    return;
                }
                break;
            case 11:
                (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.details = "Always Double-Down";
                (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.recommendation = "Double";
                return;
            case 12:
                (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.details = "Stand if 4 - 6 else Hit";
                if (showCard >= 1 && showCard <= 3 || showCard >= 7 && showCard <= 10) {
                    (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.recommendation = "Hit";
                    return;
                } else {
                    (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.recommendation = "Stand";
                    return;
                }
                break;
            case 13:
            case 14:
            case 15:
            case 16:
                (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.details = "Stand if 2 - 6 else Hit";
                if (showCard >= 7 && showCard <= 10 || showCard === 1) {
                    (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.recommendation = "Hit";
                    return;
                } else {
                    (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.recommendation = "Stand";
                    return;
                }
                break;
            case 17:
            case 18:
            case 19:
                (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.details = "On 17 - 20 always Stand";
                (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.recommendation = "Stand";
                return;
            default:
                break;
        }
    }
    CompareRecommendation(rec) {
        const modelRec = (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.recommendation;
        if (modelRec === "Blackjack!") {
            (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.answer = modelRec;
            (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.details = "Nothing to do here...";
            return;
        }
        if (rec === modelRec) {
            (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.answer = "Correct";
            (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.streak += 1;
        } else {
            (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.answer = "Incorrect";
            (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.streak = 0;
            (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.missed.push((0, $3d799ddff4431522$export$2e2bcd8739ae039).state.user.cards);
        }
    }
    GetDecks() {
        (0, $3d799ddff4431522$export$2e2bcd8739ae039).state.numberOfDecks = 4;
        const decks = [];
        for(let i = 0; i < 4; i++){
            const deck = new (0, $e2c2566beacade6b$export$c506b6be639682e0)();
            decks.push(...deck.fullDeck);
        }
        return decks;
    }
}
var $d743b5eb20e9f5e4$export$2e2bcd8739ae039 = new $d743b5eb20e9f5e4$var$GameLogic();


// import icons from 'url:../../img/icons.svg'; // Parcel 2
// Import each card image
var $fb976eabe5d70cd5$exports = {};
$fb976eabe5d70cd5$exports = new URL("card_back.96285401.svg", import.meta.url).toString();


var $8633d5de3fe8589c$exports = {};
$8633d5de3fe8589c$exports = new URL("ace_of_hearts.cac46dc9.svg", import.meta.url).toString();


var $cf8c309e3fd624f7$exports = {};
$cf8c309e3fd624f7$exports = new URL("2_of_hearts.10d04a5c.svg", import.meta.url).toString();


var $286b7358ee4315f1$exports = {};
$286b7358ee4315f1$exports = new URL("3_of_hearts.c2f95fac.svg", import.meta.url).toString();


var $18de2d0cb52fa6a2$exports = {};
$18de2d0cb52fa6a2$exports = new URL("4_of_hearts.2a23f450.svg", import.meta.url).toString();


var $ad9dd74d9ffdbf03$exports = {};
$ad9dd74d9ffdbf03$exports = new URL("5_of_hearts.21a1f2e3.svg", import.meta.url).toString();


var $f178e620db490d7d$exports = {};
$f178e620db490d7d$exports = new URL("6_of_hearts.d3df7e5d.svg", import.meta.url).toString();


var $49c665a0d4751a03$exports = {};
$49c665a0d4751a03$exports = new URL("7_of_hearts.3451cf52.svg", import.meta.url).toString();


var $c52faef4ed52c82b$exports = {};
$c52faef4ed52c82b$exports = new URL("8_of_hearts.738bb432.svg", import.meta.url).toString();


var $3623ebd07513a8a3$exports = {};
$3623ebd07513a8a3$exports = new URL("9_of_hearts.93b7c079.svg", import.meta.url).toString();


var $523def5dbe2b21bb$exports = {};
$523def5dbe2b21bb$exports = new URL("10_of_hearts.48563469.svg", import.meta.url).toString();


var $ec758d5fddfc92d2$exports = {};
$ec758d5fddfc92d2$exports = new URL("jack_of_hearts.d4fa6ff2.svg", import.meta.url).toString();


var $77a28c4e1dc6f6b1$exports = {};
$77a28c4e1dc6f6b1$exports = new URL("queen_of_hearts.7e5b4c05.svg", import.meta.url).toString();


var $2a481c496260a68b$exports = {};
$2a481c496260a68b$exports = new URL("king_of_hearts.8a765958.svg", import.meta.url).toString();


var $319bfdac6503e1d1$exports = {};
$319bfdac6503e1d1$exports = new URL("ace_of_diamonds.3ed23edc.svg", import.meta.url).toString();


var $3b6ebe92a5698871$exports = {};
$3b6ebe92a5698871$exports = new URL("2_of_diamonds.db899b18.svg", import.meta.url).toString();


var $816b16fcf09d6ea0$exports = {};
$816b16fcf09d6ea0$exports = new URL("3_of_diamonds.1703e609.svg", import.meta.url).toString();


var $6b69357a0f43ba68$exports = {};
$6b69357a0f43ba68$exports = new URL("4_of_diamonds.97012a91.svg", import.meta.url).toString();


var $b1846ca8956c59e0$exports = {};
$b1846ca8956c59e0$exports = new URL("5_of_diamonds.9674f744.svg", import.meta.url).toString();


var $b269d9448f6aafc5$exports = {};
$b269d9448f6aafc5$exports = new URL("6_of_diamonds.69b1f2ef.svg", import.meta.url).toString();


var $6894938add84745e$exports = {};
$6894938add84745e$exports = new URL("7_of_diamonds.b7308379.svg", import.meta.url).toString();


var $07bb2b3e7d21b1db$exports = {};
$07bb2b3e7d21b1db$exports = new URL("8_of_diamonds.7627c284.svg", import.meta.url).toString();


var $1dac3396254c1698$exports = {};
$1dac3396254c1698$exports = new URL("9_of_diamonds.f8e9ad8a.svg", import.meta.url).toString();


var $4fb85e85546b9c0d$exports = {};
$4fb85e85546b9c0d$exports = new URL("10_of_diamonds.f05860ba.svg", import.meta.url).toString();


var $b76f92dfd6c3b341$exports = {};
$b76f92dfd6c3b341$exports = new URL("jack_of_diamonds.8b5d6bec.svg", import.meta.url).toString();


var $c0a9395f3792817d$exports = {};
$c0a9395f3792817d$exports = new URL("queen_of_diamonds.5988f4c9.svg", import.meta.url).toString();


var $8502745519830de6$exports = {};
$8502745519830de6$exports = new URL("king_of_diamonds.4bbdc85e.svg", import.meta.url).toString();


var $91033f2f5b1f8d2f$exports = {};
$91033f2f5b1f8d2f$exports = new URL("ace_of_clubs.271b4662.svg", import.meta.url).toString();


var $64ebe55c9f55dfb5$exports = {};
$64ebe55c9f55dfb5$exports = new URL("2_of_clubs.963aced5.svg", import.meta.url).toString();


var $cb30dd8636057a21$exports = {};
$cb30dd8636057a21$exports = new URL("3_of_clubs.73910735.svg", import.meta.url).toString();


var $9de2eef536c9a996$exports = {};
$9de2eef536c9a996$exports = new URL("4_of_clubs.0e7a6885.svg", import.meta.url).toString();


var $9745752c244177ac$exports = {};
$9745752c244177ac$exports = new URL("5_of_clubs.156b0193.svg", import.meta.url).toString();


var $16412b1ab679dfeb$exports = {};
$16412b1ab679dfeb$exports = new URL("6_of_clubs.bc9b6841.svg", import.meta.url).toString();


var $eb892512e172066c$exports = {};
$eb892512e172066c$exports = new URL("7_of_clubs.6c15cd4f.svg", import.meta.url).toString();


var $64f487eb1803c648$exports = {};
$64f487eb1803c648$exports = new URL("8_of_clubs.42484cb7.svg", import.meta.url).toString();


var $1eeea3a7a0276a94$exports = {};
$1eeea3a7a0276a94$exports = new URL("9_of_clubs.dfbb5b7f.svg", import.meta.url).toString();


var $55ac501259734065$exports = {};
$55ac501259734065$exports = new URL("10_of_clubs.2fc5b090.svg", import.meta.url).toString();


var $6c028b06e06efe98$exports = {};
$6c028b06e06efe98$exports = new URL("jack_of_clubs.6867ffc0.svg", import.meta.url).toString();


var $ac03a1cd1724d3ac$exports = {};
$ac03a1cd1724d3ac$exports = new URL("queen_of_clubs.80925cd4.svg", import.meta.url).toString();


var $b943d44f77d3c818$exports = {};
$b943d44f77d3c818$exports = new URL("king_of_clubs.e80590e5.svg", import.meta.url).toString();


var $5798b8ff6a669727$exports = {};
$5798b8ff6a669727$exports = new URL("ace_of_spades.1d461cd0.svg", import.meta.url).toString();


var $a7b937afff60b3fc$exports = {};
$a7b937afff60b3fc$exports = new URL("2_of_spades.6de5df24.svg", import.meta.url).toString();


var $c47c6d2fcae9b111$exports = {};
$c47c6d2fcae9b111$exports = new URL("3_of_spades.f94cc10a.svg", import.meta.url).toString();


var $9000cfb27a7ad4fd$exports = {};
$9000cfb27a7ad4fd$exports = new URL("4_of_spades.a3b78c8b.svg", import.meta.url).toString();


var $d21e74768c94b8de$exports = {};
$d21e74768c94b8de$exports = new URL("5_of_spades.4df0b74d.svg", import.meta.url).toString();


var $14d7ad89ade0df06$exports = {};
$14d7ad89ade0df06$exports = new URL("6_of_spades.9f195352.svg", import.meta.url).toString();


var $99cee86165081cb3$exports = {};
$99cee86165081cb3$exports = new URL("7_of_spades.8192f738.svg", import.meta.url).toString();


var $c894221156f7d519$exports = {};
$c894221156f7d519$exports = new URL("8_of_spades.591a8726.svg", import.meta.url).toString();


var $867db60e718330f3$exports = {};
$867db60e718330f3$exports = new URL("9_of_spades.44d32443.svg", import.meta.url).toString();


var $1ce6fe7bc05d4443$exports = {};
$1ce6fe7bc05d4443$exports = new URL("10_of_spades.bb362507.svg", import.meta.url).toString();


var $cbf39dbe5d52969c$exports = {};
$cbf39dbe5d52969c$exports = new URL("jack_of_spades.4fda5cd4.svg", import.meta.url).toString();


var $bb68be1c80bd0b14$exports = {};
$bb68be1c80bd0b14$exports = new URL("queen_of_spades.64d7836d.svg", import.meta.url).toString();


var $b38348604f6e01d0$exports = {};
$b38348604f6e01d0$exports = new URL("king_of_spades.8c554a4f.svg", import.meta.url).toString();


const $96636196835b8aab$export$ce79dcaeb5bd6f72 = {
    card_back: (0, (/*@__PURE__*/$parcel$interopDefault($fb976eabe5d70cd5$exports))),
    // Hearts
    ace_of_hearts: (0, (/*@__PURE__*/$parcel$interopDefault($8633d5de3fe8589c$exports))),
    "2_of_hearts": (0, (/*@__PURE__*/$parcel$interopDefault($cf8c309e3fd624f7$exports))),
    "3_of_hearts": (0, (/*@__PURE__*/$parcel$interopDefault($286b7358ee4315f1$exports))),
    "4_of_hearts": (0, (/*@__PURE__*/$parcel$interopDefault($18de2d0cb52fa6a2$exports))),
    "5_of_hearts": (0, (/*@__PURE__*/$parcel$interopDefault($ad9dd74d9ffdbf03$exports))),
    "6_of_hearts": (0, (/*@__PURE__*/$parcel$interopDefault($f178e620db490d7d$exports))),
    "7_of_hearts": (0, (/*@__PURE__*/$parcel$interopDefault($49c665a0d4751a03$exports))),
    "8_of_hearts": (0, (/*@__PURE__*/$parcel$interopDefault($c52faef4ed52c82b$exports))),
    "9_of_hearts": (0, (/*@__PURE__*/$parcel$interopDefault($3623ebd07513a8a3$exports))),
    "10_of_hearts": (0, (/*@__PURE__*/$parcel$interopDefault($523def5dbe2b21bb$exports))),
    jack_of_hearts: (0, (/*@__PURE__*/$parcel$interopDefault($ec758d5fddfc92d2$exports))),
    queen_of_hearts: (0, (/*@__PURE__*/$parcel$interopDefault($77a28c4e1dc6f6b1$exports))),
    king_of_hearts: (0, (/*@__PURE__*/$parcel$interopDefault($2a481c496260a68b$exports))),
    // ... continue for Hearts (4 through King)
    // Diamonds
    ace_of_diamonds: (0, (/*@__PURE__*/$parcel$interopDefault($319bfdac6503e1d1$exports))),
    "2_of_diamonds": (0, (/*@__PURE__*/$parcel$interopDefault($3b6ebe92a5698871$exports))),
    "3_of_diamonds": (0, (/*@__PURE__*/$parcel$interopDefault($816b16fcf09d6ea0$exports))),
    "4_of_diamonds": (0, (/*@__PURE__*/$parcel$interopDefault($6b69357a0f43ba68$exports))),
    "5_of_diamonds": (0, (/*@__PURE__*/$parcel$interopDefault($b1846ca8956c59e0$exports))),
    "6_of_diamonds": (0, (/*@__PURE__*/$parcel$interopDefault($b269d9448f6aafc5$exports))),
    "7_of_diamonds": (0, (/*@__PURE__*/$parcel$interopDefault($6894938add84745e$exports))),
    "8_of_diamonds": (0, (/*@__PURE__*/$parcel$interopDefault($07bb2b3e7d21b1db$exports))),
    "9_of_diamonds": (0, (/*@__PURE__*/$parcel$interopDefault($1dac3396254c1698$exports))),
    "10_of_diamonds": (0, (/*@__PURE__*/$parcel$interopDefault($4fb85e85546b9c0d$exports))),
    jack_of_diamonds: (0, (/*@__PURE__*/$parcel$interopDefault($b76f92dfd6c3b341$exports))),
    queen_of_diamonds: (0, (/*@__PURE__*/$parcel$interopDefault($c0a9395f3792817d$exports))),
    king_of_diamonds: (0, (/*@__PURE__*/$parcel$interopDefault($8502745519830de6$exports))),
    // ... continue for Diamonds (2 through King)
    // Clubs
    ace_of_clubs: (0, (/*@__PURE__*/$parcel$interopDefault($91033f2f5b1f8d2f$exports))),
    "2_of_clubs": (0, (/*@__PURE__*/$parcel$interopDefault($64ebe55c9f55dfb5$exports))),
    "3_of_clubs": (0, (/*@__PURE__*/$parcel$interopDefault($cb30dd8636057a21$exports))),
    "4_of_clubs": (0, (/*@__PURE__*/$parcel$interopDefault($9de2eef536c9a996$exports))),
    "5_of_clubs": (0, (/*@__PURE__*/$parcel$interopDefault($9745752c244177ac$exports))),
    "6_of_clubs": (0, (/*@__PURE__*/$parcel$interopDefault($16412b1ab679dfeb$exports))),
    "7_of_clubs": (0, (/*@__PURE__*/$parcel$interopDefault($eb892512e172066c$exports))),
    "8_of_clubs": (0, (/*@__PURE__*/$parcel$interopDefault($64f487eb1803c648$exports))),
    "9_of_clubs": (0, (/*@__PURE__*/$parcel$interopDefault($1eeea3a7a0276a94$exports))),
    "10_of_clubs": (0, (/*@__PURE__*/$parcel$interopDefault($55ac501259734065$exports))),
    jack_of_clubs: (0, (/*@__PURE__*/$parcel$interopDefault($6c028b06e06efe98$exports))),
    queen_of_clubs: (0, (/*@__PURE__*/$parcel$interopDefault($ac03a1cd1724d3ac$exports))),
    king_of_clubs: (0, (/*@__PURE__*/$parcel$interopDefault($b943d44f77d3c818$exports))),
    // ... continue for Clubs (2 through King)
    // Spades
    ace_of_spades: (0, (/*@__PURE__*/$parcel$interopDefault($5798b8ff6a669727$exports))),
    "2_of_spades": (0, (/*@__PURE__*/$parcel$interopDefault($a7b937afff60b3fc$exports))),
    "3_of_spades": (0, (/*@__PURE__*/$parcel$interopDefault($c47c6d2fcae9b111$exports))),
    "4_of_spades": (0, (/*@__PURE__*/$parcel$interopDefault($9000cfb27a7ad4fd$exports))),
    "5_of_spades": (0, (/*@__PURE__*/$parcel$interopDefault($d21e74768c94b8de$exports))),
    "6_of_spades": (0, (/*@__PURE__*/$parcel$interopDefault($14d7ad89ade0df06$exports))),
    "7_of_spades": (0, (/*@__PURE__*/$parcel$interopDefault($99cee86165081cb3$exports))),
    "8_of_spades": (0, (/*@__PURE__*/$parcel$interopDefault($c894221156f7d519$exports))),
    "9_of_spades": (0, (/*@__PURE__*/$parcel$interopDefault($867db60e718330f3$exports))),
    "10_of_spades": (0, (/*@__PURE__*/$parcel$interopDefault($1ce6fe7bc05d4443$exports))),
    jack_of_spades: (0, (/*@__PURE__*/$parcel$interopDefault($cbf39dbe5d52969c$exports))),
    queen_of_spades: (0, (/*@__PURE__*/$parcel$interopDefault($bb68be1c80bd0b14$exports))),
    king_of_spades: (0, (/*@__PURE__*/$parcel$interopDefault($b38348604f6e01d0$exports)))
}; // Continue this pattern for the rest of the deck:
 // - 2, 3, 4, 5, 6, 7, 8, 9, 10, Jack, Queen, King for Diamonds, Clubs, Spades


class $c5153e9b4ebc009c$var$CardView {
    _dealerContainer = document.querySelector(".card-container--dealer");
    _userContainer = document.querySelector(".card-container--user");
    showPlayerCards(state) {
        this._clear();
        const dealerCardUp = state.dealer.cards[1];
        const dealerCardDownImage = (0, $96636196835b8aab$export$ce79dcaeb5bd6f72)["card_back"];
        const dealerCardUpImage = (0, $96636196835b8aab$export$ce79dcaeb5bd6f72)[`${dealerCardUp.value}_of_${dealerCardUp.suit}`];
        const dealerHTML = `<img class="playing-card playing-card--down-card" alt="the bakc of a playing card" src="${dealerCardDownImage}" /> <img class="playing-card playing-card--up-card" alt="a playing card of ${dealerCardUp.value} of ${dealerCardUp.suit}" src="${dealerCardUpImage}" />`;
        this._dealerContainer.insertAdjacentHTML("afterbegin", dealerHTML);
        let userHtml;
        const userCards = state.user.cards;
        userCards.forEach((card, cardNumber)=>{
            const cardImage = (0, $96636196835b8aab$export$ce79dcaeb5bd6f72)[`${card.value}_of_${card.suit}`];
            userHtml = `<img class="playing-card playing-card--user-${cardNumber + 1}" alt="a playing card of ${card.value} of ${card.suit}" src="${cardImage}" />`;
            document;
            this._userContainer.insertAdjacentHTML("afterbegin", userHtml);
        });
    }
    flipDealerCard(state) {
        const dealerDownCard = this._dealerContainer.querySelector(".playing-card--down-card");
        dealerDownCard.src = (0, $96636196835b8aab$export$ce79dcaeb5bd6f72)[`${state.dealer.cards[0].value}_of_${state.dealer.cards[0].suit}`];
    }
    _clear() {
        this._dealerContainer.innerHTML = "";
        this._userContainer.innerHTML = "";
    }
}
var $c5153e9b4ebc009c$export$2e2bcd8739ae039 = new $c5153e9b4ebc009c$var$CardView();



class $5dba2c2c2a9ec853$var$ActionView {
    _mainContainer = document.querySelector(".button-container");
    addHandlerRender(handler) {
        this._mainContainer.addEventListener("click", (e)=>{
            if (!e.target.classList.contains("btn")) return;
            const btn = e.target;
            btn.classList.add("btn--clicked");
            const action = btn.dataset.action;
            handler(action);
        });
    }
    changeButtonsBack() {
        const btns = this._mainContainer.querySelectorAll(".btn");
        btns.forEach((btn)=>{
            btn.classList.remove("btn--clicked");
        });
    }
}
var $5dba2c2c2a9ec853$export$2e2bcd8739ae039 = new $5dba2c2c2a9ec853$var$ActionView();


class $8e2a3e34675bbc4e$var$AnswerView {
    _answer = document.querySelector(".answer");
    _slogan = document.querySelector(".slogan");
    _nextButton = document.querySelector(".btn--next");
    render(state) {
        this._answer.textContent = `${state.answer}!`;
        if (state.answer === "Incorrect") this._answer.style.color = "#92b19f";
        else this._answer.style.color = "#d09632";
        this._slogan.textContent = `"${state.details}"`;
    }
    clear() {
        this._answer.textContent = "";
        this._slogan.textContent = "";
    }
}
var $8e2a3e34675bbc4e$export$2e2bcd8739ae039 = new $8e2a3e34675bbc4e$var$AnswerView();


class $11e7fbb7aafdc607$var$DealView {
    _dealContainer = document.querySelector(".deal-container");
    addHandlerRestart(handler) {
        this._dealContainer.addEventListener("click", (e)=>{
            this._addClickedClass(e, "btn--restart", handler);
        });
    }
    _addClickedClass(e, buttonType, handler) {
        if (!e.target.classList.contains(buttonType)) return;
        const btn = e.target;
        this._removeClicked();
        btn.classList.add("btn--clicked");
        handler();
    }
    _removeClicked() {
        const allDealButtons = this._dealContainer.querySelectorAll(".btn");
        allDealButtons.forEach((btn)=>btn.classList.remove("btn--clicked"));
    }
    addHandlerAces(handler) {
        this._dealContainer.addEventListener("click", (e)=>{
            this._addClickedClass(e, "btn--aces", handler);
        });
    }
    addHandlerPairs(handler) {
        this._dealContainer.addEventListener("click", (e)=>{
            this._addClickedClass(e, "btn--pairs", handler);
        });
    }
}
var $11e7fbb7aafdc607$export$2e2bcd8739ae039 = new $11e7fbb7aafdc607$var$DealView();


class $1034607220a0fd69$var$StreakView {
    _streak = document.querySelector(".streak-number");
    render(state) {
        this._streak.textContent = state.streak;
    }
}
var $1034607220a0fd69$export$2e2bcd8739ae039 = new $1034607220a0fd69$var$StreakView();


class $cbdb2545eb282b29$var$MissedView {
    _missedList = document.querySelector(".missed-container ul");
    render(state) {
        this.clear();
        const html = state.missed.map((cards, i, array)=>{
            if (i < 5) return `<li>${cards[0].value} + ${cards[1].value}</li>`;
            else if (i === 5) return `<li>...${array.length - 5} more</li>`;
        }).join("");
        this._missedList.insertAdjacentHTML("beforeend", html);
    }
    clear() {
        this._missedList.innerHTML = "";
    }
}
var $cbdb2545eb282b29$export$2e2bcd8739ae039 = new $cbdb2545eb282b29$var$MissedView();


class $35d16c8178911b95$var$StrategyCardView {
    _cardPage = document.querySelector(".strategy-card-page");
    _cardIcon = document.querySelector(".strategy-card-container");
    _body = document.querySelector("body");
    _header = document.querySelector("header");
    _pageTimeout = "";
    _settingHidePage = function() {
        this._pageTimeout = setTimeout(()=>{
            this._cardPage.classList.add("hidden");
        }, 5000);
    };
    addHandlerShowPage() {
        this._cardIcon.addEventListener("click", (e)=>{
            e.preventDefault();
            clearTimeout(this._pageTimeout);
            this._cardPage.classList.remove("hidden");
            this._cardPage.classList.remove("hide-page");
            this._cardPage.classList.add("show-page");
            this._body.classList.add("body-overflow-on");
        });
    }
    addHandlerHidePage() {
        this._header.addEventListener("click", ()=>{
            this._cardPage.classList.remove("show-page");
            this._cardPage.classList.add("hide-page");
            this._body.classList.remove("body-overflow-on");
            this._settingHidePage();
        });
    }
}
var $35d16c8178911b95$export$2e2bcd8739ae039 = new $35d16c8178911b95$var$StrategyCardView();


class $3c6e42d258545128$var$NextView {
    _nextBtn = document.querySelector(".btn--next");
    addHandler(handler) {
        this._nextBtn.addEventListener("click", handler);
    }
}
var $3c6e42d258545128$export$2e2bcd8739ae039 = new $3c6e42d258545128$var$NextView();


var $5e7e47351a4a3007$exports = {};
$5e7e47351a4a3007$exports = new URL("stand-on-15-high-resolution-logo-twitter.be96a630.png", import.meta.url).toString();


"use strict";
const $03cf872f16b5d10b$var$controlStart = function(reDeal = false, aces = false, pairs = false) {
    (0, $d743b5eb20e9f5e4$export$2e2bcd8739ae039).Deal(reDeal, aces, pairs);
    (0, $c5153e9b4ebc009c$export$2e2bcd8739ae039).showPlayerCards((0, $3d799ddff4431522$export$2e2bcd8739ae039).state);
    (0, $d743b5eb20e9f5e4$export$2e2bcd8739ae039).GetRecommendation();
};
const $03cf872f16b5d10b$var$controlAction = function(action) {
    (0, $c5153e9b4ebc009c$export$2e2bcd8739ae039).flipDealerCard((0, $3d799ddff4431522$export$2e2bcd8739ae039).state);
    (0, $d743b5eb20e9f5e4$export$2e2bcd8739ae039).CompareRecommendation(action);
    (0, $8e2a3e34675bbc4e$export$2e2bcd8739ae039).render((0, $3d799ddff4431522$export$2e2bcd8739ae039).state);
    (0, $1034607220a0fd69$export$2e2bcd8739ae039).render((0, $3d799ddff4431522$export$2e2bcd8739ae039).state);
    (0, $cbdb2545eb282b29$export$2e2bcd8739ae039).render((0, $3d799ddff4431522$export$2e2bcd8739ae039).state);
};
const $03cf872f16b5d10b$var$controlNext = function() {
    (0, $8e2a3e34675bbc4e$export$2e2bcd8739ae039).clear();
    (0, $5dba2c2c2a9ec853$export$2e2bcd8739ae039).changeButtonsBack();
    (0, $d743b5eb20e9f5e4$export$2e2bcd8739ae039).DealNext();
    (0, $c5153e9b4ebc009c$export$2e2bcd8739ae039).showPlayerCards((0, $3d799ddff4431522$export$2e2bcd8739ae039).state);
    (0, $d743b5eb20e9f5e4$export$2e2bcd8739ae039).GetRecommendation();
};
const $03cf872f16b5d10b$var$controlRestart = function() {
    (0, $8e2a3e34675bbc4e$export$2e2bcd8739ae039).clear();
    (0, $cbdb2545eb282b29$export$2e2bcd8739ae039).clear();
    (0, $5dba2c2c2a9ec853$export$2e2bcd8739ae039).changeButtonsBack();
    $03cf872f16b5d10b$var$controlStart(true);
};
const $03cf872f16b5d10b$var$controlAces = function() {
    (0, $8e2a3e34675bbc4e$export$2e2bcd8739ae039).clear();
    (0, $cbdb2545eb282b29$export$2e2bcd8739ae039).clear();
    (0, $5dba2c2c2a9ec853$export$2e2bcd8739ae039).changeButtonsBack();
    $03cf872f16b5d10b$var$controlStart(false, true);
};
const $03cf872f16b5d10b$var$controlPairs = function() {
    (0, $8e2a3e34675bbc4e$export$2e2bcd8739ae039).clear();
    (0, $cbdb2545eb282b29$export$2e2bcd8739ae039).clear();
    (0, $5dba2c2c2a9ec853$export$2e2bcd8739ae039).changeButtonsBack();
    $03cf872f16b5d10b$var$controlStart(false, false, true);
};
const $03cf872f16b5d10b$var$init = function() {
    (0, $5dba2c2c2a9ec853$export$2e2bcd8739ae039).addHandlerRender($03cf872f16b5d10b$var$controlAction);
    (0, $11e7fbb7aafdc607$export$2e2bcd8739ae039).addHandlerRestart($03cf872f16b5d10b$var$controlRestart);
    (0, $11e7fbb7aafdc607$export$2e2bcd8739ae039).addHandlerAces($03cf872f16b5d10b$var$controlAces);
    (0, $11e7fbb7aafdc607$export$2e2bcd8739ae039).addHandlerPairs($03cf872f16b5d10b$var$controlPairs);
    (0, $35d16c8178911b95$export$2e2bcd8739ae039).addHandlerShowPage();
    (0, $35d16c8178911b95$export$2e2bcd8739ae039).addHandlerHidePage();
    (0, $3c6e42d258545128$export$2e2bcd8739ae039).addHandler($03cf872f16b5d10b$var$controlNext);
    $03cf872f16b5d10b$var$controlStart();
};
$03cf872f16b5d10b$var$init();


//# sourceMappingURL=index.d91d741e.js.map
